import AuthGuard from './AuthGuard';

export default AuthGuard;
export * from './AuthGuard';
